module.exports = __webpack_public_path__ + "static/media/Logo.00ad0cda.svg";